import React, { Component } from 'react'
import AuthService from '../../services/AuthService.js' 

export class LogoutForm extends Component {
    constructor(props) {
        super(props);
    } 
    componentDidMount() {
        AuthService.logOut();
        this.props.history.push('/login');
    } 
    render() {
        return (
            <div> 
            </div >
        );
    }
}
